import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import {
  PartnerDoctorInfoList,
  PartnerDoctorEditForm,
  PartnerDoctorChangepasswordForm,
} from "../../components";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function PartnerDoctorInfoPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [tabSelectedIndex, setTabSelectedIndex] = useState(0);

  const [title, setTitle] = useState("");
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const breadcrumbItemsBase = [
    { label: "Home", path: "/", active: false },
    { label: "Doctor List", path: "/partner-doctor", active: false },

    // { label: "Doctor List", path: "/customer-doctor", active: false },
  ];

  const tabTitle = [
    "Doctor Information",
    "Edit Doctor Profile",
    "Change Password",
  ];

  function onTitleClick(e) {
    var itemIndex = e.itemIndex;
    setTabSelectedIndex(itemIndex);
    setTitle(tabTitle[itemIndex]);
    setBreadcrumbItems(
      breadcrumbItemsBase.concat({
        label: tabTitle[itemIndex],
        path: "#",
        active: true,
      })
    );
    setFetchTrigger((prevTrigger) => prevTrigger + 1);
  }

  useEffect(() => {
    if (user.usertype === "CP" || user.usertype === "DIST") {
      setTitle(tabTitle[0]);
      setBreadcrumbItems(
        breadcrumbItemsBase.concat({
          label: tabTitle[0],
          path: "#",
          active: true,
        })
      );
    } else {
      navigate("/");
    }
  }, []);

  return (
    <React.Fragment>
      <Breadcrumb title={title} items={breadcrumbItems} />
      <TabPanel
        className={"content-block dx-card responsive-paddings"}
        swipeEnabled={false}
        scrollByContent={true}
        showNavButtons={true}
        onTitleClick={onTitleClick}
      >
        <Item title="Doctor Information">
          <PartnerDoctorInfoList fetchTrigger={fetchTrigger} />
        </Item>

        <Item title="Edit Doctor Information">
          <PartnerDoctorEditForm />
        </Item>

        <Item title="Change Password">
          <PartnerDoctorChangepasswordForm />
        </Item>
      </TabPanel>
    </React.Fragment>
  );
}
